export default function Authorization() {
  return (
    <div>Coming soon...</div>
  );
}
